export default __webpack_public_path__ + "static/media/pic4.ca831d08.jpg";